import { parseVideoUrl } from "@/utils/video";

interface VideoTourProps {
  videoUrl?: string | null;
  title?: string;
  className?: string;
}

/**
 * "Video Tour" widget for a business listing.
 *
 * Renders a responsive 16:9 player for a YouTube, Vimeo or other streaming
 * link. Renders nothing when no usable link is supplied — plan gating is
 * handled by the caller so a non-Premium listing simply never shows it.
 */
export default function VideoTour({ videoUrl, title = "Video Tour", className = "" }: VideoTourProps) {
  const video = parseVideoUrl(videoUrl);
  if (!video) return null;

  return (
    <div className={className}>
      <h3 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-foreground-800">
        <span className="flex h-4 w-4 items-center justify-center text-accent-600">
          <i className="ri-play-circle-line text-base" />
        </span>
        {title}
      </h3>
      <div className="mt-3 aspect-video w-full overflow-hidden rounded-md border border-background-200 bg-foreground-950">
        {video.kind === "video" ? (
          <video src={video.src} controls playsInline className="h-full w-full object-cover" />
        ) : (
          <iframe
            src={video.src}
            title={`${title} video`}
            className="h-full w-full"
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
}